export const STORAGE_PREFIX = "exw:result:"

export function storageKey(exerciseId) {
  return `${STORAGE_PREFIX}${exerciseId}`
}

function storage() {
  try {
    return globalThis.localStorage || null
  } catch {
    return null
  }
}

export function saveResult(exerciseId, result) {
  if (!exerciseId || !result) return false

  const store = storage()
  if (!store) return false

  try {
    store.setItem(storageKey(exerciseId), JSON.stringify(result))
    return true
  } catch {
    return false
  }
}

export function readResult(exerciseId) {
  if (!exerciseId) return null

  const store = storage()
  if (!store) return null

  try {
    const raw = store.getItem(storageKey(exerciseId))
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function parseExerciseJson(source) {
  if (typeof source !== "string" || !source.trim()) return null

  try {
    return JSON.parse(source)
  } catch {
    return null
  }
}
